export default {
  0: 'Arc de Triomphe',
  1: 'Big Ben',
  2: 'Casa Loma',
  3: 'Castel Santangelo',
  4: 'Charlottenburg Palace',
  5: 'Colosseum',
  6: 'Dresden Frauenkirche',
  7: 'Eiffel Tower',
  8: 'Independence Hall',
  9: 'Leaning Tower of Pisa',
  10: 'Milan Cathedral',
  11: 'Notre Dame Cathedral',
  12: 'Pantheon',
  13: 'Reichstag',
  14: 'Sacre Coeur Basilica',
  15: 'Savior on Blood Church',
  16: 'St Basil Cathedral',
  17: 'St Louis Cathedral',
  18: 'St Paul Cathedral',
  19: 'Statue of Liberty',
  20: 'Stephansdom',
  21: 'Taj Mahal',
  22: 'Trevi Fountain',
  23: 'Tyn Church',
  24: 'Westminster Abbey',
};



// WEBPACK FOOTER //
// ./src/components/classes.js